import { Box, Grid, useTheme } from '@mui/material'
import CellHOC from '@platform/react/hoc/list/cell'
import { getSubLabel } from 'lib/util/string'
import ApplicationContext from 'platform/react/context/application'
import { useContext } from 'react'
import Text from 'ui/Element/Text'

const styles = theme => ({
  row: {
    gap: 12,
    flexWrap: 'nowrap',
  },
  subLabel: {
    gap: 4,
  },
})

/**
 * Displays an equipment name.
 *
 * @param {Object} classes  element's style classes
 * @param {Object} props    element's properties
 *
 * @returns {JSX.Element}
 */
export const ListItemCellFavoriteRequestName = (classes, props = {}) => {
  const { intl } = useContext(ApplicationContext)
  const { number, createdLabel, submit: { timestamp: submitTimestamp = null } = {}} = props
  const subLabel = getSubLabel(Text, [createdLabel, intl.getLocaleDate(submitTimestamp)])

  return (
    <Grid
      container
      direction={'row'}
      className={classes.row}
    >
      <Grid
        item
        xs={'auto'}
        alignSelf={'stretch'}
      >
        <Grid
          container
          gap={'0.125rem'}
          direction={'column'}
          alignItems={'flex-start'}
          justifyContent={'center'}

          sx={{ height: '100%' }}
        >
          <Text
            maxLines={1}
            value={number}
            variant={'14/bold'}
            color={'black.main'}
          />
          {createdLabel && submitTimestamp && (
            <Grid
              item
              container
              xs={'auto'}
              className={classes.subLabel}
            >
              {subLabel}
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  )
}

export default CellHOC(ListItemCellFavoriteRequestName, styles)
